export default __webpack_public_path__ + "static/media/skrill.6f358b5f.svg";